export const REQUEST_SUMMARY_INFORMATION = 'DASHBOARD/REQUEST_SUMMARY_INFORMATION';
export const REQUEST_SUMMARY_INFORMATION_SUCCESS = 'DASHBOARD/REQUEST_SUMMARY_INFORMATION_SUCCESS';
export const REQUEST_SUMMARY_INFORMATION_FAILURE = 'DASHBOARD/REQUEST_SUMMARY_INFORMATION_FAILURE';
